exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account_box[data-v-66887a33]{padding:20px 20px 40px 20px}.title[data-v-66887a33]{font-size:20px;font-weight:600}.search_criteria[data-v-66887a33]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.search_criteria>div[data-v-66887a33]{margin:0 5px;width:180px}", ""]);

// exports
